import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { getAssetManagerInitialValues } from '../utils.ts';
import { validationSchemaAssetManagerGeneralInfo } from '../validationSchema.ts';
import * as yup from 'yup';
import { cloneDeep } from 'lodash';
import { TGeneralInfoAssetManager } from '../types.ts';
import { selectGeneralInfo } from '~/store/identification-form/selectors.ts';

export const useGeneralInfoAssetManagerForm = () => {
  const generalInfo = useSelector(selectGeneralInfo);

  const initialValues = getAssetManagerInitialValues(generalInfo as TGeneralInfoAssetManager);

  const schema = yup.lazy(() => validationSchemaAssetManagerGeneralInfo);

  const form = useForm<TGeneralInfoAssetManager>({
    resolver: yupResolver(schema) as unknown as Resolver<TGeneralInfoAssetManager>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
